import { createSelector } from "reselect";
import moment from "moment";
import { deepGet } from "../../../utils";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const appointmentSelector = state => state.appointment;
const dataSourceSelector = state => state.dataSource;
const waitingListSelector = state => state.waitingList;

const getState = (config, booking, appointment, dataSource, waitingList) => {
  const {
    specialtyTypes,
    practitioners,
    appointmentTypes,
    locations,
    timeZones,
    positions
  } = dataSource;

  const {
    specialtyType,
    practitioner,
    appointmentType,
    location,
    timezone,
    appointmentDateTime
  } = appointment;

  const practitionerDetail = practitioners.find(
    p => p.practitionerId === practitioner
  );

  const locationDetail = locations.find(l => l.locationId === location);
  return {
    requireWaitingList: waitingList.required,
    waitingListConfirmationText: config.waitingListConfirmationText,
    hideSpecialty:
      config.preSelectSpecialtyType && config.preSelectSpecialtyType !== "",
    hidePractitioner:
      config.preSelectPractitioner && config.preSelectPractitioner !== "",
    completedSteps: booking.completedSteps,
    anyPractitioner: config.preSelectPractitioner === "ANY",
    specialtyType: deepGet(
      specialtyTypes.find(s => s.specialtyTypeId === specialtyType),
      ["name"]
    ),
    appointmentType: deepGet(
      appointmentTypes.find(a => a.appointmentTypeId === appointmentType),
      ["description"]
    ),
    practitioner:
      practitioner === "ANY" || !practitioner
        ? "ANY Practitioner"
        : practitionerDetail
          ? `${practitionerDetail.firstName} ${practitionerDetail.lastName}`
          : "",
    location:
      location === "ANY" || !location
        ? "ANY Location"
        : locationDetail
          ? `${locationDetail.name}, ${locationDetail.suburb}`
          : "",
    locationAddress: locationDetail
      ? `${locationDetail.streetAddress}, ${locationDetail.suburb} ${
          locationDetail.postcode
        }, ${locationDetail.country}`
      : "",
    position: locationDetail ? positions[locationDetail.locationId] : null,
    timezone: deepGet(timeZones.find(t => t.timezoneUID === timezone), [
      ["description"]
    ]),
    appointmentDateTime: waitingList.required
      ? `${waitingList.preferredTime} preferred`
      : appointmentDateTime
        ? moment
            .parseZone(appointmentDateTime.startDateTime)
            .format("hh:mma, Do MMM YYYY")
        : "",
    appointmentStartTime: appointmentDateTime
      ? moment
          .parseZone(appointmentDateTime.startDateTime)
          .format("YYYYMMDDTHHmmss")
      : "",
    appointmentEndTime: appointmentDateTime
      ? moment
          .parseZone(appointmentDateTime.endDateTime)
          .format("YYYYMMDDTHHmmss")
      : "",
    isMedibank: config.tenant === "medibank"
  };
};

const appointmentSummarySelector = createSelector(
  configSelector,
  bookingSelector,
  appointmentSelector,
  dataSourceSelector,
  waitingListSelector,
  getState
);

export { appointmentSummarySelector };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/selectors/appointmentSummarySelector.js